import { useForm } from "react-hook-form";
import Input from "../../components/Input";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import moduloApi from "../../utility/api/moduloApi";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../features/user";
import Swal from "sweetalert2";
import { useCallback, useEffect, useState } from "react";
import Dropdown from "../../components/Dropdown";
import ButtonClasses from "../../components/Button/typing";
import CancelarButton from "../../components/CancelarButton";
import { NotAllowed, permissoes, useAthorize } from "../../hooks/useAthorize";

const CadastroModulo = ({ setIsVisible, onFinished }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm();

  let isAllowed = useAthorize(
    permissoes.moduloConsulta,
    permissoes.moduloFull
  );

  const token = useSelector(selectUserToken);
  const [divisoes, setDivisoes] = useState([]);

  const onSubmit = useCallback(
    async ({ nome, divisoes, link }) => {
      let data = {
        nome,
        divisoes,
        link,
      };

      let result = await moduloApi.cadastrarModulo(data, token);

      if (result.hasError) {
        Swal.fire({
          title: "Erro!",
          text: "Algo deu errado",
          icon: "error",
        });
        return;
      }

      if (result.data.length === 0) {
        reset();
        onFinished?.();

        Swal.fire({
          title: "Sucesso!",
          text: "Cadastrado com sucesso",
          icon: "success",
        });
        return;
      }

      Swal.fire({
        title: "Erro!",
        text: result.data,
        icon: "error",
      });
    },
    [onFinished, reset, token]
  );

  const fetchDivisoes = useCallback(async () => {
    var result = await moduloApi.buscarDivisoes(token);

    if (result.hasError) {
      Swal.fire({
        title: "Erro!",
        text: "Algo deu errado",
        icon: "error",
      });
      return;
    }

    setValue("divisaoId", "");
    setDivisoes(result.data);
  }, [setValue, token]);

  useEffect(() => {
    fetchDivisoes();
  }, [fetchDivisoes]);

  var footer = (
    <>
      <CancelarButton
        watch={watch}
        reset={() =>
          Swal.fire({
            text: "Realmente deseja cancelar o cadastro?",
            showDenyButton: true,
            confirmButtonText: "Sim",
            denyButtonText: `Não`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              reset();

              Swal.fire({
                text: "Cancelado com sucesso!",
                icon: "success",
              });
            }
          })
        }
        getValues={getValues}
        voltar={() => setIsVisible()}
      />
      <Button
        colorClass={ButtonClasses.DarkGreen}
        text="Salvar"
        onClick={handleSubmit(onSubmit)}
      />
    </>
  );

  if (!isAllowed) return <NotAllowed />;

  return (
    <Modal
      setModal={setIsVisible}
      title="Cadastro de Módulo"
      footer={footer}
      height="h-auto"
      heightBody="h-[64%] py-6"
    >
      <div className="w-full h-full flex justify-center items-center">
        <form onSubmit={handleSubmit(onSubmit)} className="w-[86%]">
          <div className="grid grid-cols-1 gap-6">
            <Input
              label="Nome"
              name="nome"
              type="text"
              placeholder="Insira o nome do módulo"
              register={register}
              required
              errors={errors}
            />
            <Dropdown
              name="divisoes"
              defaultText="Selecione a divisao"
              register={register}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              options={divisoes}
              width={"w-full"}
              label="Divisão"
              errors={errors}
              required
              multiple
            />
            <Input
              label="Link"
              name="link"
              type="text"
              placeholder="Insira o link de apontamento"
              register={register}
              required
              errors={errors}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default CadastroModulo;
